import { render, staticRenderFns } from "./saveBudgetModal.vue?vue&type=template&id=a8ef4d72&"
import script from "./saveBudgetModal.vue?vue&type=script&lang=js&"
export * from "./saveBudgetModal.vue?vue&type=script&lang=js&"
import style0 from "./saveBudgetModal.vue?vue&type=style&index=0&id=a8ef4d72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports